import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import Modal from '../Modal';

const ErrorModal = props => {
  const { closeErrorModal, message, errorModal } = props;
  return (
    <Modal
      title='Une erreur est survenue'
      color='danger'
      isOpen={errorModal}
      handleClose={() => closeErrorModal()}
      onClick={() => closeErrorModal()}
      btnColor='danger'
      btnTxt="D'accord"
      message={message}
    />
  );
};

function mapStateToProps({ modals }) {
  const { errorModal, message } = modals;
  return {
    message,
    errorModal
  };
}

export default connect(mapStateToProps, actions)(ErrorModal);
